// In-memory store for the access token — enables Bearer-based auth for cross-domain API calls.
// Populated on SSR hydration and after each token refresh.
let _memAccessToken: string | null = null;

export function getAccessToken(): string | null {
  return _memAccessToken;
}

export function setMemAccessToken(token: string | null): void {
  _memAccessToken = token;
}

/**
 * @deprecated Tokens are now stored in HTTP-only cookies via API routes.
 * Use the login API route instead.
 */
export function setTokens(_access: string, _refresh: string) {
  console.warn(
    'setTokens is deprecated. Tokens are now stored in HTTP-only cookies.',
  );
}

/**
 * Refreshes the access token using the refresh token stored in HTTP-only cookie.
 * Also stores the new token in the in-memory store for cross-domain Bearer auth.
 */
export async function refreshAccessToken(): Promise<string | null> {
  if (typeof window === 'undefined') return null;

  try {
    const res = await fetch('/api/auth/refresh-token', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!res.ok) {
      _memAccessToken = null;
      return null;
    }

    const data = await res.json();
    const newToken: string | null = data.accessToken || null;
    if (newToken) {
      _memAccessToken = newToken;
    }

    console.log('Access token refreshed successfully');
    return newToken || 'refreshed';
  } catch (error) {
    console.error('Failed to refresh access token:', error);
    return null;
  }
}
